import React, { useState, useEffect } from 'react';
import { useMessages } from '../../context/MessageContext';
import HomeMessageInbox from './HomeMessageInbox';
import Modal from '../../utils/modalUtils';

const DUMMY_ROW_COUNT = 7;

const showComingSoon = (e) => {
    if (e) e.preventDefault();
    Modal.fire({
        icon: 'error',
        title: '',
        text: 'Coming soon!',
        confirmButtonText: 'OK',
        confirmButtonColor: '#addd1e',
        centerContent: true,
    });
};

const HomeMessageBoard = () => {
    const { messages = [], fetchMessagesForHome } = useMessages();
    const [selectedMessage, setSelectedMessage] = useState(null);

    const hasMessages = messages.length > 0;

    useEffect(() => {
        fetchMessagesForHome();

        const refresh = () => {
            setSelectedMessage(null);
            fetchMessagesForHome();
        };
        window.addEventListener('cityChange', refresh);
        window.addEventListener('storage', refresh);
        return () => {
            window.removeEventListener('cityChange', refresh);
            window.removeEventListener('storage', refresh);
        };
    }, [fetchMessagesForHome]);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";

        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "N/A";

        const options = {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        return new Intl.DateTimeFormat('en-US', options).format(date).replace(',', '');
    };

    useEffect(() => {
        if (!selectedMessage && messages.length > 0) {
            setSelectedMessage(messages[0]);
        }
    }, [messages, selectedMessage]);

    return (
        <div className="msgboard-section home-public-board">
            <div className="row">
                <div id="inbox" className="col-sm-12">
                    <div className="heading-golfer">
                        <h4>PUBLIC MESSAGE BOARD</h4>
                        <img src="/images/public-bd-icon.png" alt="Messages" />
                    </div>
                    <div className="clear" />

                    <div className="tbl-msg-div shadow">
                        <div className="home-msg-scroll">
                        <table cellSpacing={0} id="message" className="messages" cellPadding={0}>
                            <thead>
                                <tr>
                                    <th>Player</th>
                                    <th>Subject</th>
                                    <th>Posted</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hasMessages ? (
                                    messages.map((msg, index) => (
                                        <tr
                                            key={msg.id || index}
                                            className={`${index % 2 === 0 ? 'even' : 'odd'}${selectedMessage === msg ? ' selected' : ''}`}
                                            onClick={() => setSelectedMessage(msg)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td>{msg.poster ? msg.poster : msg.sender || 'Unknown'}</td>
                                            <td className="msg-subject">
                                                {msg.subject || 'No Subject'}
                                            </td>
                                            <td>{formatDate(msg.date ? msg.date : msg.read_date) || 'N/A'}</td>
                                        </tr>
                                    ))
                                ) : (
                                    Array.from({ length: DUMMY_ROW_COUNT }).map((_, index) => (
                                        <tr
                                            key={`dummy-${index}`}
                                            className={`dummy-msg-row ${index % 2 === 0 ? 'even' : 'odd'}`}
                                        >
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
                {selectedMessage ? (
                    <HomeMessageInbox message={selectedMessage} onPostMessage={showComingSoon} />
                ) : (
                    <div id="inbox-message" className="col-sm-12">
                        <div className="heading-golfer">
                            <h4>Message Preview</h4>
                        </div>
                        <div className="msg-preview-section">
                            <div className="home-preview-box">
                                <div id="msgheader">
                                    <h2><b><span className="msg-label">Subject:</span></b></h2>
                                </div>
                                <div id="msg">&nbsp;</div>
                               
                            </div>
                             <div className="home-post-wrap">
                                    <a
                                        href="#!"
                                        onClick={showComingSoon}
                                        className="reply-link ie-post-link green"
                                    >
                                        Post a Message
                                    </a>
                                </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HomeMessageBoard
